import { render, staticRenderFns } from "./DirectionForm.vue?vue&type=template&id=6f2e67db&scoped=true&"
import script from "./DirectionForm.vue?vue&type=script&lang=js&"
export * from "./DirectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e67db",
  null
  
)

export default component.exports